<div class="container loading-container" *ngIf="$progressValue | async as progress">
    <progressbar class="loading-progressbar" type="warning" [value]="progress"></progressbar>
    <p class="loading-sub">Loading takeoff tool</p>
</div>
